<template>
  <div class="logined">
    <img :src="avatar ? avatar : userInfo.avatar">
    <span>{{ name ? 'Hi,'+name : userInfo.username }}</span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import defaultAvatar from '@/assets/avatar@2x.png';

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({
        username: '欢迎来到柔宇灯塔,请登陆',
        avatar: defaultAvatar,
      }),
    },
  },
  data() {
    return {
      isLogined: false,
    };
  },
  computed: {
    ...mapGetters([
      'avatar',
      'name',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.logined {
  float: left;
  img{
    margin-right: 10px;
    border-radius: 50%;
    width: 38px;
    vertical-align: middle;
  }
  span {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: #788acb;
  }
}
</style>
